import type { AnnotatedEvidenceLatest } from '../../services/annotatedEvidenceApi';

function text(value: unknown): string {
  return String(value || '').trim().toLowerCase();
}

export function hasEmbeddedVisualOverlay(data: AnnotatedEvidenceLatest | null | undefined): boolean {
  const overlay = text(data?.image_snapshot_overlay);
  return overlay === 'detections' || overlay === 'annotated_overlay' || overlay === 'overlay';
}

export function shouldBrowserOverlayAnnotatedEvidence(
  data: AnnotatedEvidenceLatest | null | undefined,
): boolean {
  return !hasEmbeddedVisualOverlay(data);
}

export function shouldIncludeOverlayHeader(
  data: AnnotatedEvidenceLatest | null | undefined,
): boolean {
  const overlay = text(data?.image_snapshot_overlay);
  return overlay !== 'audit_text' && overlay !== 'annotated_text';
}
